// src/components/guide/SampleBadge.jsx
import React from 'react';
import { Badge } from '../ui/badge';
import { useGuide } from '../../contexts/GuideContext';

export default function SampleBadge({ id }) {
  const guide = useGuide();
  if (!guide?.isSample?.(id)) return null;
  return <span className="guide-sample"><Badge variant="info">Sample</Badge><button type="button" className="v2-text-action" onClick={e => { e.preventDefault(); e.stopPropagation(); guide.claim(id); }}>Make it mine</button></span>;
}
